import React from 'react'
import {
  toast as toastRAW,
  ToastContainer as ToastContainerRAW,
  ToastContainerProps
} from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'
import './index.css'

import FeedbackCard from './FeedbackCard'
import { FeedbackCardEmitterOptions, ToastProps } from './type'
import isMobileViewportWidth from '~/utils/responsive/isMobileViewportWidth'

export const FeedbackCardContainer = (props: ToastContainerProps) => (
  <ToastContainerRAW
    position={isMobileViewportWidth() ? 'top-center' : 'top-right'}
    autoClose={5000}
    hideProgressBar={true}
    newestOnTop
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    pauseOnHover
    limit={4}
    closeButton={false}
    {...props}
  />
)

const FeedbackCardComponent = ({ toastProps: { data } }: ToastProps) => (
  <FeedbackCard {...data} />
)

export const feedbackcard = (
  title: string,
  {
    message,
    type,
    heightClass,
    displayDateTime = true,
    ...toastProps
  }: FeedbackCardEmitterOptions
) => {
  toastRAW(<FeedbackCardComponent toastProps={{ data: { title: '' } }} />, {
    data: { title, message, type, heightClass, displayDateTime },
    position: isMobileViewportWidth() ? 'top-center' : 'top-right',
    ...toastProps
  })
}
